module.exports = __webpack_public_path__ + "static/a4-610b6bb91b861d8aedab4f38fa8b4951.jpg";